import React from "react";
import "./CheckBox.css";

function CheckBox({ title, description, checked, onChange, divider }) {
  return (
    <div className="entry">
      <label className="checkbox-wrapper ">
        <input className={checked ? "checked" : ""} type="checkbox" checked={checked} onChange={onChange} />
        <div className="label-text">
          <p className="label-title">{title}</p>
          <p className="label-descr">{description}</p>
        </div>
      </label>
      {!divider && <div className="divider" />}
    </div>
  );
}

export default CheckBox;
